export default "__VITE_PUBLIC_ASSET__7428a53d__"